'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Content, GroupField } from '@prismicio/client';
import React from 'react';
import DesktopTable from '@/components/molecules/DesktopTable';
import MobileCrypto from '@/components/molecules/MobileCrypto';
import { useCryptos } from '@/hooks/UseCryptos';
import { Simplify } from '@/prismicio-types';
import { CryptoTableType, HeaderWithTooltip } from '@/utils/types';
import FeesTables from '../FeesTables';
type Props = {
  coins: GroupField<Simplify<Content.CoinsDocumentDataCoinsItem>>;
  variant: 'sellTable' | 'buyTable' | 'sellFeesAndLimits' | 'buyFeesAndLimits';
  headers: HeaderWithTooltip[];
  howToButtonLabelMap: Record<string, string>;
};
const CryptoTableWrapper = t0 => {
  const $ = _c(12);
  const {
    coins,
    headers,
    variant,
    howToButtonLabelMap
  } = t0;
  const t1 = variant == "sellTable" ? "sellOnly" : "all";
  let t2;
  if ($[0] !== coins || $[1] !== t1) {
    t2 = {
      coins,
      filter: t1
    };
    $[0] = coins;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: rows,
    isLoading
  } = useCryptos(t2);
  let t3;
  if ($[3] !== howToButtonLabelMap) {
    t3 = ticker => howToButtonLabelMap[ticker] || "";
    $[3] = howToButtonLabelMap;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getHowToButtonLabel = t3;
  let t4;
  if ($[5] !== getHowToButtonLabel || $[6] !== headers || $[7] !== isLoading || $[8] !== rows?.error || $[9] !== rows?.result || $[10] !== variant) {
    t4 = <>{rows?.error ? <div className="o-container o-container--xl my-8"><div className="text-body-7 flex items-center justify-center rounded-lg border border-gray-200 p-8 font-bold">{rows?.error}</div></div> : variant === "buyTable" || variant === "sellTable" ? <><DesktopTable rows={rows?.result?.filter(row => row.sellValue !== "-" || variant !== "sellTable")} variant={variant} headers={headers} isLoading={isLoading} howToButtonLabel={getHowToButtonLabel} /><MobileCrypto rows={rows?.result?.filter(row_0 => row_0.sellValue !== "-" || variant !== "sellTable")} variant={variant} headers={headers} isLoading={isLoading} howToButtonLabel={getHowToButtonLabel} /></> : <FeesTables rows={rows?.result} variant={variant} isLoading={isLoading} headers={headers} />}</>;
    $[5] = getHowToButtonLabel;
    $[6] = headers;
    $[7] = isLoading;
    $[8] = rows?.error;
    $[9] = rows?.result;
    $[10] = variant;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default CryptoTableWrapper;